import {AttendanceTrackerAssignmentType} from '../backend/enums/attendance-tracker-assignment-type';
import {useAuth} from '../contexts/auth/context';

/**
 * Whether the logged user must or can track attendance in the selected entity: the attendance tracker
 * is enabled in the entity and the user is not "not applicable".
 */
export const useCanTrackAttendance = (): boolean => {
  const {state} = useAuth();
  const affiliation = state.session?.selectedAffiliation;

  return (
    affiliation?.attendanceTracker?.isEnabled === true &&
    affiliation.attendanceTracker.assignment !== AttendanceTrackerAssignmentType.NotApplicable
  );
};
